import './Products.css'

interface Product {
  id: string
  name: string
  description: string
  features: string[]
}

const products: Product[] = [
  {
    id: 'fusion',
    name: 'MULTI-DOMAIN FUSION PLATFORM',
    description:
      'Unified platform fusing biometric, cyber, and RF signals for real-time identity resolution.',
    features: [
      'Cross-domain entity correlation',
      'Real-time threat alerting',
      'Graph-based persona modeling',
      'NATO-compatible data formats',
    ],
  },
  {
    id: 'edge',
    name: 'EDGE DEVICES',
    description:
      'Portable, self-contained edge appliances with cameras, RF sensors, and onboard AI.',
    features: [
      'Tactical deployment ready',
      'On-device ML inference',
      'Low-power operation',
      'Mesh networking capable',
    ],
  },
  {
    id: 'analytics',
    name: 'PERSONA ANALYTICS',
    description:
      'Continuous persona profile construction from multi-signal data with AI-driven correlation.',
    features: [
      'Behavioral pattern analysis',
      'Cross-session tracking',
      'Anomaly detection',
      'Identity confidence scoring',
    ],
  },
  {
    id: 'detection',
    name: 'THREAT DETECTION',
    description:
      'Multi-factor alert system detecting impersonation, infiltration, and data exfiltration.',
    features: [
      'Real-time monitoring',
      'Low false-positive rate',
      'Automated response triggers',
      'Audit trail logging',
    ],
  },
]

export default function Products() {
  return (
    <div className="products-app">
      <header className="products-header">
        <h1>SOLUTIONS CATALOG</h1>
        <p className="products-subtitle">
          Enterprise-grade identity intelligence solutions for defense and security
        </p>
      </header>

      <div className="products-grid">
        {products.map((product) => (
          <article key={product.id} className="product-card">
            <h2 className="product-name">{product.name}</h2>
            <p className="product-description">{product.description}</p>
            <ul className="product-features">
              {product.features.map((feature, index) => (
                <li key={index}>► {feature}</li>
              ))}
            </ul>
            <div className="product-status">
              <span className="status-indicator" />
              AVAILABLE
            </div>
          </article>
        ))}
      </div>

      <footer className="products-footer">
        <p>Contact sales@personascience.com for pricing and demonstrations</p>
      </footer>
    </div>
  )
}
